import { useState } from 'react';

const cardItems = [
  {
    id: 1,
    title: '全网最新电影资源库',
    desc: '海量高清电影每日更新，从好莱坞大片到文艺佳作，分类清晰查找方便',
    icon: 'ri-film-line',
    colorClass: 'text-primary-500',
    bgClass: 'bg-primary-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20movie%20library%20visual%20with%20organized%20film%20shelves%2C%20warm%20cinematic%20lighting%2C%20coral%20and%20golden%20tones%2C%20minimalist%20interior%20design%2C%20clean%20aesthetic%2C%20entertainment%20concept&width=640&height=440&seq=cd-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '热播剧集追更日历',
    desc: '电视剧追剧时间表一目了然，国产剧韩剧美剧同步更新，再也不怕错过更新',
    icon: 'ri-calendar-todo-line',
    colorClass: 'text-accent-600',
    bgClass: 'bg-accent-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Calendar%20schedule%20visual%20with%20TV%20drama%20episodes%20layout%2C%20warm%20planning%20aesthetic%2C%20amber%20and%20soft%20peach%20tones%2C%20minimalist%20organizer%20design%2C%20clean%20style&width=640&height=440&seq=cd-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '高清画质流畅播放',
    desc: '1080P全高清在线播放，智能CDN加速技术，无论何时何地都能零缓冲流畅观影',
    icon: 'ri-4k-line',
    colorClass: 'text-secondary-600',
    bgClass: 'bg-secondary-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=High%20definition%20streaming%20visual%20with%20smooth%20playback%20interface%2C%20modern%20technology%20elements%2C%20warm%20coral%20and%20soft%20gray%20tones%2C%20minimalist%20tech%20design%2C%20clean%20aesthetic&width=640&height=440&seq=cd-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '多元题材任你选择',
    desc: '动作、喜剧、悬疑、科幻、爱情、动画……超全题材分类，满足全家人的观影口味',
    icon: 'ri-stack-line',
    colorClass: 'text-primary-500',
    bgClass: 'bg-primary-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Diverse%20movie%20genre%20collage%20visual%20with%20colorful%20category%20cards%2C%20warm%20vibrant%20lighting%2C%20coral%20amber%20peach%20tones%2C%20minimalist%20grid%20layout%2C%20clean%20modern%20design&width=640&height=440&seq=cd-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '每日更新抢先知',
    desc: '每天早上10点准时更新最新影视资源，热门电影和电视剧第一时间上线，精彩不错过',
    icon: 'ri-notification-3-line',
    colorClass: 'text-accent-600',
    bgClass: 'bg-accent-100',
    imageUrl: 'https://readdy.ai/api/search-image?query=Daily%20update%20notification%20visual%20with%20fresh%20content%20arrival%2C%20warm%20morning%20lighting%2C%20golden%20and%20soft%20amber%20tones%2C%20minimalist%20modern%20design%2C%20clean%20notification%20concept&width=640&height=440&seq=cd-05-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            苹果视频为你精心挑选的优质内容和特色服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item) => (
            <InfoCard key={item.id} item={item} />
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardItems.slice(3, 5).map((item) => (
            <InfoCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function InfoCard({ item }: { item: typeof cardItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer">
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.imageUrl}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent pointer-events-none"></div>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className={`w-10 h-10 rounded-xl ${item.bgClass} flex items-center justify-center`}>
            <i className={`${item.icon} ${item.colorClass} text-lg`}></i>
          </div>
          <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
        </div>
        <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
      </div>
    </div>
  );
}